import { Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";

import ModalContent from "../components/modal/ModalContent";
import { SharedModalProps } from "../components/modal/ModalContextProvider";

const PaymentSuccessModal = ({ handleClose }: SharedModalProps) => {
  return (
    <ModalContent label="Gelukt!">
      <Typography marginBottom="1em">
        Je gegevens zijn verstuurd. Bedankt dat je deze demonstrant wil helpen!
      </Typography>
      <Stack direction="row" justifyContent="end">
        <Button
          sx={{ margin: "1em" }}
          type="button"
          variant="text"
          onClick={handleClose}
        >
          Sluiten
        </Button>
      </Stack>
    </ModalContent>
  );
};

export default PaymentSuccessModal;
